import { createSelector } from 'reselect';

import { StoreState } from '../index';

export const assortmentSelector = (state: StoreState) => state.assortment;

export const assortmentApiSelector = createSelector(
  assortmentSelector,
  (assortment) => assortment.assortmentApi
);

export const baseAssortmentSelector = createSelector(
  assortmentSelector,
  (assortment) => assortment.baseAssortment
);